<template>
  <div class="delete-dialog">
    <el-dialog
      title=""
      :visible.sync="display"
      width="30%"
      center>
      <div style="text-align:center">确定删除该角色吗？</div>
       <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      display: this.show
    }
  },
  mounted () {
    console.log(this.display)
  },
  watch: {
    show: function (nval) {
      this.display = nval // show改变是同步子组件display的值
    },
    display: function (nval) {
      this.$emit('update:show', nval) // display改变时同步父组件show的值
    }
  },
  methods: {
    cancel () {
      this.display = false
    },
    confirm () {
      this.display = false
    }
  }

}
</script>

<style lang='scss' scoped>

</style>
